var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.back()}}},[_c('img',{attrs:{"src":require("@/assets/img/back-icon.svg"),"alt":"preview"}})])}
var staticRenderFns = []

export { render, staticRenderFns }